export default __webpack_public_path__ + "static/media/login-name.58bdefaf.svg";